// src/components/Layout/Layout.js
import React from 'react';
import Header from '../Header/Header';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

/**
 * Layout component that wraps pages to provide a consistent 
 * Header, Navbar, and Footer.
 */
const Layout = ({ children }) => {
  return (
    <div className="app-layout">
      <div className="header-nav-wrapper">
        <Header />
        <Navbar />
      </div>
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
